export type HelpLink = { label: string; href: string };

export type HelpTrainingSection = {
	id: string;
	title?: string;
	intro?: string;
	links?: HelpLink[];
};

export const helpCenterTrainingIntro =
	"To know more about the use of the application, you can consult these materials provided for user support:";

export const helpCenterTrainingSections: HelpTrainingSection[] = [
	{
		id: "user-guide",
		title: "User guide",
		links: [
			{
				label: "User guide of the application",
				href: "https://doi.org/10.4060/cd8682en",
			},
		],
	},
	{
		id: "data-checklist",
		title: "Data checklist",
		links: [
			{
				label: "ENGLISH",
				href: "https://openknowledge.fao.org/handle/20.500.14283/cd7207en",
			},
			{
				label: "SPANISH",
				href: "https://openknowledge.fao.org/handle/20.500.14283/cd7207es",
			},
			{
				label: "FRENCH",
				href: "https://openknowledge.fao.org/handle/20.500.14283/cd7207fr",
			},
			{
				label: "RUSSIAN",
				href: "https://openknowledge.fao.org/handle/20.500.14283/CD7207RU",
			},
		],
	},
	{
		id: "intro-video",
		title: "Introductory video",
		links: [
			{
				label: "Introductory video on EX-ACT for small and medium enterprises",
				href: "https://www.youtube.com/watch?v=lQAgt6IZqXg",
			},
		],
	},
	{
		id: "module-videos",
		title: "YouTube videos on how to fill specific modules of the tool",
		links: [
			{
				label: "The EX-ACT app: annual cropland",
				href: "https://youtu.be/PKp37s5ZwqA",
			},
			{
				label: "The EX-ACT app: aquaculture",
				href: "https://youtu.be/kg7peSJRF18",
			},
			{
				label: "The EX-ACT app: flooded rice management",
				href: "https://youtu.be/_P_vO9GcFrk",
			},
			{
				label: "The EX-ACT app: forest management",
				href: "https://youtu.be/jGhTfg8sj9U",
			},
			{
				label: "The EX-ACT app: grassland management",
				href: "https://youtu.be/8wCRN8uylQc",
			},
			{
				label: "The EX-ACT app: land use change",
				href: "https://youtu.be/-wP27daIxUM",
			},
			{
				label: "The EX-ACT app: livestock management",
				href: "https://youtu.be/Uz9atHjEI48",
			},
			{
				label: "The EX-ACT app: organic soils",
				href: "https://youtu.be/R_yAj7vbP44",
			},
			{
				label: "The EX-ACT app: perennial cropland",
				href: "https://youtu.be/lPwHcKWE3XA",
			},
			{
				label: "The EX-ACT app: agricultural inputs",
				href: "https://youtu.be/0Ehahd9OgkQ",
			},
			{
				label: "The EX-ACT app: settlements and infrastructure",
				href: "https://youtu.be/b4nwHS8VyLE",
			},
			{
				label: "The EX-ACT app: storage, packaging, transport, processing",
				href: "https://youtu.be/OiL6hms2jtw",
			},
			{
				label: "The EX-ACT app: fisheries",
				href: "https://youtu.be/161zksZ-cMQ",
			},
		],
	},
];
